module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.type == 'presentation') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('md-input-container', [_c('label', [_vm._v("Cím")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('md-checkbox', {
    model: {
      value: (_vm.form.isSection),
      callback: function($$v) {
        _vm.$set(_vm.form, "isSection", $$v)
      },
      expression: "form.isSection"
    }
  }, [_vm._v("Szekció")]), _vm._v(" "), (_vm.form.isSection) ? _c('md-checkbox', {
    model: {
      value: (_vm.form.displayHours),
      callback: function($$v) {
        _vm.$set(_vm.form, "displayHours", $$v)
      },
      expression: "form.displayHours"
    }
  }, [_vm._v("Óra és perc kijelzése")]) : _vm._e()], 1)]), _vm._v(" "), _c('img', {
    staticClass: "formImage",
    attrs: {
      "src": _vm.form.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('md-input-container', [_c('label', [_vm._v("Kép (link)")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.image),
      callback: function($$v) {
        _vm.$set(_vm.form, "image", $$v)
      },
      expression: "form.image"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadImage
    }
  })])]), _vm._v(" "), (_vm.uploading) ? _c('md-progress', {
    attrs: {
      "md-indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Előadók")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.lecturerNames),
      callback: function($$v) {
        _vm.$set(_vm.form, "lecturerNames", $$v)
      },
      expression: "form.lecturerNames"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tAz előadókat vesszővel elválasztva kell felsorolni.\n\t\t\t\t")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Leírás")]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "config": _vm.ckeditor
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'lecturer') ? _c('div', [_c('md-input-container', [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Titulus")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Cég")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.origin),
      callback: function($$v) {
        _vm.$set(_vm.form, "origin", $$v)
      },
      expression: "form.origin"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Kép (link)")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.image),
      callback: function($$v) {
        _vm.$set(_vm.form, "image", $$v)
      },
      expression: "form.image"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Bemutatkozás")]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "config": _vm.ckeditor
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
    staticClass: "block dates"
  }, [_c('h4', [_vm._v("Időpontok")]), _vm._v(" "), _c('date-picker', {
    staticClass: "date-picker",
    attrs: {
      "date": _vm.form.fromDate,
      "option": _vm.option
    }
  }), _vm._v(" "), _c('span', [_vm._v("-tól")]), _vm._v(" "), _c('date-picker', {
    staticClass: "date-picker",
    attrs: {
      "date": _vm.form.toDate,
      "option": _vm.option
    }
  }), _vm._v(" "), _c('span', [_vm._v("-ig")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Időtartam (perc)")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.duration),
      callback: function($$v) {
        _vm.$set(_vm.form, "duration", $$v)
      },
      expression: "form.duration"
    }
  })], 1), _vm._v("\n\t\t\t\tA következő új előadás szerkesztésénél az előző előadás időpontjának vége az alapértelmezett kezdő időpont.\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block attachments"
  }, [_c('h4', [_vm._v("Csatolmányok, kapcsolati adatok")]), _vm._v(" "), _c('attachment-block', {
    attrs: {
      "attachments": _vm.form.attachments
    }
  })], 1), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
    staticClass: "block lecturers"
  }, [_c('h4', [_vm._v("Szülő szekció")]), _vm._v(" "), _c('md-select', {
    staticClass: "col-md-12",
    model: {
      value: (_vm.form.section),
      callback: function($$v) {
        _vm.$set(_vm.form, "section", $$v)
      },
      expression: "form.section"
    }
  }, _vm._l((_vm.presentations), function(pres) {
    return _c('md-option', {
      attrs: {
        "value": pres.fireId
      }
    }, [_vm._v(_vm._s(pres.title))])
  })), _vm._v("\n\t\t\t\tBármelyik előadás választható egy előadás szekciójaként. A következő új előadás szerkesztésénél az előző előadás szekciója kerül használatra.\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
    staticClass: "block lecturers"
  }, [_c('h4', [_vm._v("Előadók")]), _vm._v(" "), _vm._l((_vm.form.lecturers), function(lecturer, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-select', {
      staticClass: "col-md-10",
      model: {
        value: (_vm.form.lecturers[index]),
        callback: function($$v) {
          _vm.$set(_vm.form.lecturers, index, $$v)
        },
        expression: "form.lecturers[index]"
      }
    }, _vm._l((_vm.lecturers), function(lect) {
      return _c('md-option', {
        attrs: {
          "value": lect.value
        }
      }, [_vm._v(_vm._s(lect.label))])
    })), _vm._v(" "), _c('p', {
      staticClass: "col-md-2"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeLecturer(index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1)])], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.form.lecturers.push({})
      }
    }
  }, [_vm._v("Előadó hozzáadása")])], 2) : _vm._e(), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
    staticClass: "block location"
  }, [_c('h4', [_vm._v("Helyszín")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', _vm._l((_vm.locations), function(loc) {
    return _c('md-radio', {
      attrs: {
        "md-value": loc.fireId
      },
      model: {
        value: (_vm.form.location.fireId),
        callback: function($$v) {
          _vm.$set(_vm.form.location, "fireId", $$v)
        },
        expression: "form.location.fireId"
      }
    }, [_vm._v(_vm._s(loc.name))])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('md-checkbox', {
    model: {
      value: (_vm.form.closed),
      callback: function($$v) {
        _vm.$set(_vm.form, "closed", $$v)
      },
      expression: "form.closed"
    }
  }, [_vm._v("Csak cím mutatása")]), _vm._v(" "), _c('md-checkbox', {
    model: {
      value: (_vm.form.hidden),
      callback: function($$v) {
        _vm.$set(_vm.form, "hidden", $$v)
      },
      expression: "form.hidden"
    }
  }, [_vm._v("Teljes elrejtés")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-warn",
    nativeOn: {
      "click": function($event) {
        _vm.remove()
      }
    }
  }, [_vm._v("Törlés")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Mentés")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('h3', [_vm._v("Szerkesztő")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64c1ed4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/EditorView.vue
// module id = 555
// module chunks = 2